<template>
<div class="expertCookbookadd"  >
    <div class="top"> 
        <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
        <el-button type="primary" size="medium" @click="insertPublicMenus(0)">保存</el-button>  
        <el-button type="primary" size="medium" @click="insertPublicMenus(1)">发布</el-button>   
    </div>
    <div class="subject" :style="`height: ${windowHeight-180}px;`">
      <div class="body">
        <div class="box">
            <div class="nav"><span>名称</span></div> 
            <div class="box-box" >
                  <div class="ul-top">                    
                    <div class="li">     
                         <div class="name"><div class="red">*</div>食谱名称</div> 
                         <el-input v-model.trim="name" :maxlength="15" placeholder="请输入食谱名称"></el-input>
                    </div>
              </div>             
            </div>
        </div>
          <div class="box">
            <div class="nav"><span>周一</span> <i class="el-icon-circle-plus-outline" @click="popfun(1)"></i></div> 
            <div class="box-box" v-if="mondayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in mondayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                         <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(1,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
          <div class="box">
            <div class="nav"><span>周二</span> <i class="el-icon-circle-plus-outline" @click="popfun(2)"></i></div> 
            <div class="box-box" v-if="tuesdayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in tuesdayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(2,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
          <div class="box">
            <div class="nav"><span>周三</span> <i class="el-icon-circle-plus-outline" @click="popfun(3)"></i></div> 
            <div class="box-box" v-if="wednesdayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in wednesdayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                       <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(3,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
          <div class="box">
            <div class="nav"><span>周四</span> <i class="el-icon-circle-plus-outline" @click="popfun(4)"></i></div> 
            <div class="box-box" v-if="thursdayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in thursdayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(4,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
          <div class="box">
            <div class="nav"><span>周五</span> <i class="el-icon-circle-plus-outline" @click="popfun(5)"></i></div> 
            <div class="box-box" v-if="fridayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in fridayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                         <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(5,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
          <div class="box">
            <div class="nav"><span>周六</span> <i class="el-icon-circle-plus-outline" @click="popfun(6)"></i></div> 
            <div class="box-box" v-if="saturdayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in saturdayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(6,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
          <div class="box">
            <div class="nav"><span>周日</span> <i class="el-icon-circle-plus-outline" @click="popfun(7)"></i></div> 
            <div class="box-box" v-if="sundayFood.length>0">
                  <div class="ul">                    
                    <div class="li" v-for="(item,index) in sundayFood" :key="index">     
                        <span class="img"  :style="`background-image: url(${item.foodPic})`"></span>
                        <span>{{item.foodName}}</span>
                        <span>{{item.foodTypeName}}</span>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top">
                          <i class="el-icon-delete" @click="deletefun(7,index)"></i>
                        </el-tooltip>                       
                    </div>
              </div>             
            </div>
             <div v-else class="noData">暂无安排！</div>
          </div>
      </div>
    </div>   
    <el-dialog title="选择菜品" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisible" width="800px" :lock-scroll="false" :modal-append-to-body='false'>
		 <div class="foot-top">        
        <el-col :span="18">
             <el-radio-group v-model="typeId">
              <el-radio-button :label="item.id" v-for="item in foodTypeList" :key="item.id">{{item.value}}</el-radio-button>
            </el-radio-group>
        </el-col>
        <el-col :span="6">
                <el-input size="medium"  placeholder="请输入菜品名称" v-model.trim="searchName">
                  <el-button size="medium" slot="append" icon="el-icon-search" ></el-button>
                </el-input>
        </el-col>
     </div>
     <div class="select-box">
       <div class="name" v-if="xuanzhonglist.length==0">菜品选中区</div>
       <div class="box"  v-for="(item,index) in xuanzhonglist" :key="index">
         <img :src="item.foodPic" alt="">{{item.foodName}}<i class="el-icon-close" @click="xuanzhonglistfun(item.foodId)"></i>
      </div>
     </div>
     <div class="food-box">
        <el-checkbox-group v-model="foodtypelist" @change="foodChange()">
          <el-checkbox  border v-for="item in foodlist" :key="item.id" :label="item.id" v-show="(item.typeId==typeId)&&indexoffun(item.name)">
            <img class="img" :src="item.pic" alt="">
            {{item.name}}
          </el-checkbox>
        </el-checkbox-group>
     </div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible=false">取 消</el-button>
				<el-button type="primary" @click="dialogVisiblefun()">确 定</el-button>
			</span>
		</el-dialog>   
</div> 
</template>
<script>
import {insertPublicMenu,chooseSchoolFood,findDicsByCode} from "@/api/foodSetting";
import mixin from "@/mixins/windowResize";
import { mapGetters} from 'vuex';
export default {
  data() {
    return {
     mondayFood:[],//1 
     tuesdayFood:[],//2
     wednesdayFood:[],//3
     thursdayFood:[],//4
     fridayFood:[],//5
     saturdayFood:[],//6
     sundayFood:[],//7
     name:'',
     schoolInfotype:'',
     dietMenuWeek:'',
     schoolTimeId:'',
     schoolTimeName:'',
     showMenu:'',
     mynum:'',
     foodTypeList:[],
     typeId:'',
     searchName:'',
     dialogVisible:false,
     dietMenuWeeklist:[],     
     foodlist:[],
     foodtypelist:[],
     xuanzhonglist:[] 
    };
  },
  mixins: [mixin],
  computed: {...mapGetters(['schoolInfo'])},
  created() {
    this.schoolInfotype=this.schoolInfo.type;
    findDicsByCode('foodType').then(res=>{                
                this.foodTypeList=res.data.data;
                this.typeId=this.foodTypeList[0].id;               
            }).catch();
     this.chooseSchoolFoods()
  },
  methods: {
    //保存
    insertPublicMenus(showMenu){
      if(!this.name){
          this.$message({type: 'error', message:'请输入食谱名称!'});
          return;
      };
      let znum=this.mondayFood.length+this.tuesdayFood.length+this.wednesdayFood.length+this.thursdayFood.length+this.fridayFood.length+this.saturdayFood.length+this.sundayFood.length;
      if(!znum){
          this.$message({type: 'error', message:'菜谱不能为空!'});
          return;
      }; 
      let obj={
        mondayFoodIds:this.stringifyfun(this.mondayFood),//1 
        tuesdayFoodIds:this.stringifyfun(this.tuesdayFood),//2
        wednesdayFoodIds:this.stringifyfun(this.wednesdayFood),//3
        thursdayFoodIds:this.stringifyfun(this.thursdayFood),//4
        fridayFoodIds:this.stringifyfun(this.fridayFood),//5
        saturdayFoodIds:this.stringifyfun(this.saturdayFood),//6
        sundayFoodIds:this.stringifyfun(this.sundayFood),//7
        name:this.name,
        showMenu:showMenu
      };
      let $this=this;
      insertPublicMenu(obj)
              .then(res => {
                if (res.data.code === 200) {
                  $this.$message({
                    type: "success",
                    message: "操作成功!"
                  });
                  $this.$router.go(-1);
                }                
              }).catch();
    },
    stringifyfun(list){
        let ids='';
         for(let i=0;i<list.length;i++){
            if(i<list.length-1){
                ids=ids+list[i].foodId+',';
            }else{
                ids=ids+list[i].foodId
            }
         }
        return ids;
    },
   //删除
   deletefun(num,index){
      if(num==1){
        this.mondayFood.splice(index,1)
      };
      if(num==2){
        this.tuesdayFood.splice(index,1)
      };
      if(num==3){
        this.wednesdayFood.splice(index,1)
      };
      if(num==4){
        this.thursdayFood.splice(index,1)
      };
      if(num==5){
        this.fridayFood.splice(index,1)
      };
      if(num==6){
        this.saturdayFood.splice(index,1)
      };
      if(num==7){
        this.sundayFood.splice(index,1)
      };
   },
   //删除选中的菜品
   xuanzhonglistfun(id){
    for(let i=0;i<this.foodtypelist.length;i++){
        if(this.foodtypelist[i]==id){          
          this.foodtypelist.splice(i,1)
        };
    };
    this.foodChange();
   },
   //弹框
   popfun(num){
     this.mynum=num;
     this.typeId=this.foodTypeList[0].id;
     this.dialogVisible=true;
     this.foodtypelist=[];
     this.xuanzhonglist=[];
   },
   //弹框勾选
   foodChange(){   	
     this.xuanzhonglist=[];
     for(let i=0;i<this.foodtypelist.length;i++){
       for(let j=0;j<this.foodlist.length;j++){
         if(this.foodtypelist[i]==this.foodlist[j].id){           
          this.xuanzhonglist.push({
            foodId:this.foodlist[j].id,
            foodName:this.foodlist[j].name,
            foodPic:this.foodlist[j].pic,
            foodTypeName:this.foodlist[j].typeName,
          })
         }
       }
     }
   },
   //搜索
   indexoffun(name){
     if(!this.searchName){
       return true;
     }else{
         return name.indexOf(this.searchName) != -1;
     };   
   },
   //确定取消
   dialogVisiblefun(){
     this.dialogVisible=false;
     if(this.xuanzhonglist.length==0){
           this.$message({type: 'error', message:'请选择菜品!'});
          return;
     }else{
        if(this.mynum==1){    
          let foodName='';      
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.mondayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.mondayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.mondayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName!=''){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
        if(this.mynum==2){
          let foodName='';      
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.tuesdayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.tuesdayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.tuesdayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
        if(this.mynum==3){
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.wednesdayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.wednesdayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.wednesdayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
        if(this.mynum==4){
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.thursdayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.thursdayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.thursdayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
        if(this.mynum==5){
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.fridayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.fridayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.fridayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
        if(this.mynum==6){
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.saturdayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.saturdayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.saturdayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
        if(this.mynum==7){
          for(let i=0;i<this.xuanzhonglist.length;i++){
             let is=true;
             for(let j=0;j<this.sundayFood.length;j++){
               if(this.xuanzhonglist[i].foodId==this.sundayFood[j].foodId){
                 is=false;
               }
             };
             if(is){
                this.sundayFood.push(this.xuanzhonglist[i])
             }else{
               foodName+=this.xuanzhonglist[i].foodName;
             }
          }
          if(foodName){
            this.$message({type: 'error', message:foodName+'菜品重复!'});
          }
        };
     }
   },
   //获取菜品
   chooseSchoolFoods(){
     chooseSchoolFood('','0').then(res=>{                
                let mydata=res.data.data;
                this.foodlist=mydata;
            }).catch();
   }
  }
};
</script>
<style lang="scss" scoped>
.expertCookbookadd {
   padding: 12px;
    *{
          box-sizing: border-box;
        }  
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .el-dialog__body{
    padding: 10px;
  }
  .foot-top{
    overflow: hidden;
  }
  .select-box{
    height: 50px;
    margin: 10px 0;
    border-top: 1px #EBEEF5 solid;
    border-bottom: 1px #EBEEF5 solid;
    padding: 5px;
    overflow: auto;
    .name{
      line-height: 38px;
      font-size: 20px;
      color:#C0C4CC;
    }
    .box{
      float: left;
      height: 38px;      
      img{
        float: left;
        width: 30px;
        height: 30px;
      }
      line-height: 30px;
      font-size: 14px;
      border:1px  #EBEEF5 solid;
      padding: 3px;
      border-radius: 3px;
      margin-right: 5px;
      i{
        font-size: 18px;
        cursor:pointer;        
      }
      i:hover{
        color:#f56c6c;
      }
    }
  }
  .food-box{
      height: 181px;
      overflow: auto;
      border-bottom: 1px #EBEEF5 solid;
    .img{
        width: 45px;
        height: 45px;
        left: 40px;
        position: absolute;
        top: 5px;
    }
    .el-checkbox.is-bordered {        
          height: 80px;
          min-width: 130px;
          padding: 50px 10px 10px 10px;
          margin: 5px;
      }
  }
  .subject {
    padding-top: 10px;
    overflow: auto;
    .body{
      width: 810px;
      margin: 0 auto;
      .el-form-item {
                margin-bottom: 0px;              
      }
      .box{          
        background-color: #F0F0F0;
        overflow: hidden;       
         .noData{
          text-align: center;
          line-height: 80px;
          font-size: 16px;
          color: #303133;
          background: #fff
        }     
        .nav{
          height: 20px;
          line-height: 20px;
          margin: 10px;
          padding-left: 8px;
          border-left: 4px solid #409EFF;
          color: #333; 
          .el-icon-circle-plus-outline{
                  font-size: 20px;
                  margin-left: 10px;
                  color: #C0C4CC;
                  cursor: pointer;                 
               }
                .el-icon-circle-plus-outline:hover{
                    color:#409EFF
                  }         
        }
        .box-box{
          background: #fff;
          overflow: hidden;
          .ul-top{
            .li{
              position: relative;
              padding:10px 10px 10px 110px;
              .el-select{
                  width: 100%;
                }
              .name{
                position: absolute;
                width: 100px;
                text-align: right;
                top: 10px;
                left: 0px;
                line-height: 40px;
                font-size: 14px;               
                .red{
                  display: inline;
                  color:#f56c6c;
                }

              }
            }
          }
          .ul{              
            .li{
               overflow: hidden;
               padding:5px 0;
               border-bottom: 1px #EBEEF5 solid;
               span{
                float: left;
                line-height: 40px;
                width: 300px;
                font-size: 14px;
                color: #606266;
                text-align: center;  
                .el-input {
                    width: 70px;
                    margin: 0 5px;
                }         
               } 
               .el-icon-delete{
                  line-height: 40px;
                  font-size: 20px;
                  float: right;
                  margin-right: 10px;
                  color: #606266;
                  cursor:pointer;                  
               }
                .el-icon-delete:hover{
                    color:#F56C6C
                  }
                .img{
                  height: 40px;
                  width: 40px;
                  background-position: center center;
                  background-size: cover;
                  margin: 0 15px 0 5px;
               }
             }
          }
      }      
    }
    
  }
    
  }
   
}
</style>


// WEBPACK FOOTER //
// src/views/foodSetting/expertCookbookadd.vue